export function AppClassToggle(className: string, action: 'add' | 'remove' | 'toggle' = 'toggle'): void {
    document.querySelector('umb-market-app')!.classList[action](className);
}